import { useContext, useEffect } from 'react';
import { LoadingReducerContext } from '../components/Pages';

const useLoading = (loading) => {
  const { dispatch } = useContext(LoadingReducerContext);

  useEffect(() => {
    if (loading) {
      dispatch({ type: 'START_LOADING' });
    } else {
      dispatch({ type: 'END_LOADING' });
    }
    return () => {
      dispatch({ type: 'END_LOADING' });
    };
  }, [loading, dispatch]);
};

export default useLoading;
